import React, { useEffect } from "react";
import { useState, useRef } from "react";
import "./Events.scss";
import { Formik, Form, FieldArray } from "formik";
import {
  Box,
  Button,
  Grid,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import FormikControl from "components/wrapperComponents/FormikControl";
import { EventsModel } from "model/screensModels/EventsModel";
import { EventsService } from "services/menu/eventsService/EventsService";
import { EventsSchema } from "schemas/menu/events/EventsSchema";
import { msgTypes } from "constants/msgTypes";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { UtilService } from "services/shared/UtilService";
import DeleteIcon from '@mui/icons-material/Delete';
import { InputLabel } from "@material-ui/core";

export const CreateEvent = ({ setFlag, updateRecord }) => {

  const [activeStep, setActiveStep] = useState(0);
  const [countryList, setCountryList] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const [initialValues, setInitialValues] = useState(new EventsModel());
  const [currencyList, setCurrencyList] = useState([]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const formikRef = useRef(null);



  useEffect(() => {
    if (updateRecord) {
      setInitialValues(updateRecord)
      setIsDirty(true);
    }
  }, [updateRecord])





  useEffect(() => {
    loadCountry();
    getCurrencyList();
  }, []);

  //load country
  const loadCountry = async () => {
    const res = await UtilService.getCountryList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCountryList(res.data);
    }
  };

 
  const getCurrencyList = async () => {
    const res = await UtilService.getCurrencyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCurrencyList(res.data);
    }
  };



  const prepareRequestBody = async (
    values: EventsModel
  ): Promise<EventsModel> => {
    const prepareData = new EventsModel();

    //to assing id based on action

    if (initialValues.eventId?.length > 0) {
      prepareData.eventId = initialValues.eventId;
    } else {
      prepareData.eventId = values.eventId ? values.eventId : "";
    }
    prepareData.eventName = values.eventName ?? prepareData.eventName;
    prepareData.eventStartDate = values.eventStartDate ?? prepareData.eventStartDate;
    prepareData.eventEndDate = values.eventEndDate ?? prepareData.eventEndDate;
    prepareData.eventVenue = values.eventVenue ?? prepareData.eventVenue;
    prepareData.country = values.country ?? prepareData.country;
    prepareData.image = values.image ?? prepareData.image;
    prepareData.createConference = values.createConference ?? prepareData.createConference;

 


    return prepareData;
  };

  const addEvents = async (values: EventsModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await EventsService.addEvents(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValues(new EventsModel());
      setActiveStep(0);
      setFlag(false)
      return true;
    } else {
      return false;
    }
  };



  return (
    <div>
      <Box
        className="event-height event-main-box"
        width="100%"
        height="100%"
        margin="0 auto"
        padding="10px"
      >
        <Grid container justifyContent="center">
          <Paper className="event-paper outer-container">
            {/* <Typography variant="h5" align="center" className="pt-3">
        Events Registration Form
      </Typography> */}

            <Formik
              innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={EventsSchema[activeStep]}
              // onSubmit={handleSubmit}
              onSubmit={async (values, { resetForm }) => {
                const res = await addEvents(values);
                if (res) resetForm();
              }}
            >
              {({
                isSubmitting,
                isValid,
                dirty,
                values,
                errors,
                touched,
                handleChange,
              }) => (
                <Form>
                  <div className="row">
            
                    <div className="col-lg-12">
                      <div className="card border-0 h-100 dash-one p-3">
                        <div className="stepper-body h-100">
                          {activeStep === 0 && (
                            <>
                              <div className="container h-100 d-flex flex-column justify-content-between">
                                <div className="row">
                                  <div className="col-12">
                                    <h1 className="event-heading">Event Details</h1>
                                  </div>
                                  <div className="col-md-6 position-relative">
                                    <FormikControl
                                      control="textfield"
                                      name="eventName"
                                      label="Event Name"
                                      placeholder="Event name"
                                      requiredField
                                      disabled={false}
                                    />
                                  </div>
                                  <div className="col-md-6 position-relative">
                                    <FormikControl
                                      control="datepicker"
                                      name="eventStartDate"
                                      label="Event Start Date"
                                      placeholder="Start Date"
                                      requiredField
                                      disabled={false}
                                    />
                                  </div>
                                  <div className="col-md-6 position-relative">
                                    <FormikControl
                                      control="datepicker"
                                      name="eventEndDate"
                                      label="Event End Date"
                                      placeholder="End Date"
                                      requiredField
                                      disabled={false}
                                    />
                                  </div>
                                  <div className="col-md-6 position-relative">
                                    <FormikControl
                                      control="textfield"
                                      name="eventVenue"
                                      label="Event Venue"
                                      placeholder="Event Venu"
                                      requiredField
                                      disabled={false}
                                    />
                                  </div>
                                  <div className="col-md-6 position-relative">
                                    <FormikControl
                                      control="autocomplete"
                                      name="country"
                                      label="Country"
                                      placeholder="Select Country"
                                      requiredField
                                      options={countryList}
                                      keyfield="name"
                                      valuefield="countryIdentifier"
                                    />
                                  </div>

                                  <div className="col-lg-6 col-md-6 position-relative">
                                    <FormikControl control='uploadImage'
                                      requiredField
                                      name="imageFile"
                                      label="Upload Image"
                                      tooltip = {[msgTypes.DOCUMENT_TYPE.JPG, msgTypes.DOCUMENT_TYPE.JPEG,
                                        msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                      nameUrl="image"
                                    />
                                  </div>
                                  <div className="col-md-12 position-relative">
                                    <FormikControl
                                      control="textfield"
                                      name="createConference"
                                      label=" Conference Link"
                                      placeholder="Enter Conference Link"
                                      requiredField
                                      disabled={false}
                                    />
                                  </div>

                                </div>
                                <div className='col-12 d-flex justify-content-end'>

 
  <FormikControl control='button' className="btn-submit btn" color="primary" label={values.eventId === '' ? "Save" : "Update"} type="submit" disabled={!dirty || !isValid || isSubmitting} />&nbsp;&nbsp;

  <FormikControl control='button' className="btn-cancel btn" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />

</div>

                              </div>
                            </>
                          )}


                        </div>
                      </div>
                    </div>
                  </div>
    
                </Form>
              )}
            </Formik>
          </Paper>
        </Grid>
      </Box>
    </div>
  )
}

